<app-header></app-header>
<main id="main-content" #mainContent>
<router-outlet (activate)="onActivate($event)"></router-outlet>
</main>
<app-google-analytics-gtag></app-google-analytics-gtag>
<app-footer></app-footer>
